import { SET_SELECTION_MENU } from "../Types";

export const setSelectionMenu = (selectedMenu) => (dispatch) => {
  dispatch({
    type: SET_SELECTION_MENU,
    payload: selectedMenu,
  });
};
